<mat-toolbar>
  <div class="title">
    <button [routerLink]="logoLink" mat-flat-button>
      <img alt="Logo" src="assets/png/logo.png">
    </button>
    <div>
      {{ ss.titleInfo }}
      <pre class="versioninfo">{{ ss.env.buildInfo }}</pre>
    </div>
  </div>
  <div>
    {{ ss.titleToolbar }}
  </div>
  @if (ss.isDebug) {
    <div class="debug-outer">
      <a class="debug" href="{{ss.env.dbAdminUrl}}" i18n mat-button target="_blank">DB Admin</a>
      <div class="debug">
        @for (perm of permissionList; track perm) {
          @if (perm.may) {
            <mat-icon>{{ perm.icon }}</mat-icon>
          }
        }
      </div>
    </div>
  }
  <div row>
    @if (ss.mayDebug) {
      <button (click)="debugClick()" logo mat-flat-button>
        <mat-icon>
          {{ ss.isDebug ? 'pest_control' : 'bug_report' }}
        </mat-icon>
      </button>
    }
    <button (click)="accountClick()" logo mat-flat-button>
      <mat-icon [class]="ss.session.user?.isAuthorized||false?'loggedin':'loggedout'">
        {{ ss.session.user?.isAuthorized ? 'how_to_reg' : 'login' }}
      </mat-icon>
    </button>
  </div>
</mat-toolbar>
<div class="content">
  <router-outlet></router-outlet>
</div>
